import Enums from "../../utilities/enum"
export const TransferLiabilityContactDetails = ({ contact }) => {
    return <>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">First Name</p>
            </div>
            <div className="col-md-6 col-12 ">{ contact.firstName }</div>
        </div>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">Last Name</p>
            </div>
            <div className="col-md-6 col-12 ">{ contact.lastName }</div>
        </div>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">Company Name</p>
            </div>
            <div className="col-md-6 col-12 ">{ contact.companyName }</div>
        </div>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">Email Address</p>
            </div>
            <div className="col-md-6 col-12 ">{ contact.emailAddress }</div>
        </div>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">Contact Number</p>
            </div>
            <div className="col-md-6 col-12 ">{ contact.mobilePhoneNumber }</div>
        </div>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">Contact Type</p>
            </div>
            <div className="col-md-6 col-12 ">
                { Enums.ContactTypes[contact.contactType] }
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-3">Contact Source</p>
            </div>
            <div className="col-md-6 col-12 ">
                { Enums.ContactSource[contact.contactSource] }
            </div>
        </div>
        <div className="row">
            <div className="col-12 col-md-6">
                <p className="font-weight-semi-bold mb-3">Address</p>
            </div>
            <div className="col-12 col-md-6">
                { contact.addressLine1 && <>{ contact.addressLine1 }<br /></> }
                { contact.addressLine2 && <>{ contact.addressLine2 }<br /></> }
                { contact.addressLine3 && <>{ contact.addressLine3 }<br /></> }
                { contact.townOrCity && <>{ contact.townOrCity }<br /></> }
                { contact.county && <>{ contact.county }<br /></> }
                { contact.postCode && <>{ contact.postCode }<br /></> }
                { contact.country && <>{ contact.country }<br /></> }
            </div>
        </div>
        <div className="row align-items-center">
            <div className="col-md-6 col-12 ">
                <p className="font-weight-semi-bold  mb-1">Status</p>
            </div>
            <div className="col-md-6 col-12  ">{ contact.isActive && <i className="fas fa-check text-success"></i> }{ !contact.isActive && <i className="fas fa-times text-danger"></i> }</div>
        </div>
        { contact.attachment !== null &&
            <div className="row align-items-center">
                <div className="col-md-6 col-12 ">
                    <p className="font-weight-semi-bold mb-0">Attachment</p>
                </div>
                <div className="col-md-6 col-12 ">
                    <div className="row align-items-center">
                        <div className="col-6 d-flex align-items-center">
                            <a href={ contact.attachment.url } target="_blank"><h6 className="mb-0 mr-2">{ contact.attachment.filename }</h6></a>
                            { !contact.attachment.isImage && <>
                                { contact.attachment.contentType === "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-6x fa-file-pdf"></i></div> }
                                { contact.attachment.contentType === "application/word.doc" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-word"></i></div> }
                                { contact.attachment.contentType !== "application/word.doc" && contact.attachment.contentType !== "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-alt"></i></div> }
                            </> }
                        </div>
                        <div className="col-6">
                            { contact.attachment.isImage && <img src={ contact.attachment.url } className="attachment-thumb" /> }
                        </div>
                    </div>
                </div>
            </div> }
    </>
}